import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

const useAnalytics = () => {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    // Track page view on route change
    const page = location.pathname + location.search;
    if (page === lastTracked.current) return;
    lastTracked.current = page;

    const trackPageView = async () => {
      try {
        await axios.post(`${API}/analytics/track`, {
          event_type: 'pageview',
          page: page,
          referrer: document.referrer || null,
          metadata: {
            title: document.title,
            screen_width: window.innerWidth,
            screen_height: window.innerHeight,
          }
        });
      } catch (e) {
        // Silently fail - analytics should not break the app
      }
    };

    trackPageView();
  }, [location]);
};

export default useAnalytics;
